import * as Sentry from '@sentry/browser'

import { isDev } from '../utils'

export default (Vue, options = {}) => {
  Sentry.init({
    dsn: 'https://3323c7c87efe49e0b8db4d7c86116f1b@sentry.duoke.net/10',
    integrations: [
      new Sentry.Integrations.Vue({ Vue }),
      new Sentry.Integrations.GlobalHandlers(),
    ],
    environment: process.env.NODE_ENV,
    enabled: !isDev(),
    release: process.env.VERSION,
  })
  Sentry.configureScope((scope) => {
    if (options.category) {
      scope.setTag('category', options.category)
    }
    scope.addBreadcrumb({ category: options.category || 'h5' })
    scope.setUser({ email: options.email || 'duokeserver@163.com' })
  })
}



// WEBPACK FOOTER //
// ./src/views/sentry.js